import { localizationSvc } from '@SharedServices/localization.service';

export function IsModelStateError(xhr) {
    return xhr.status == 400;
}

//notes for validation
//errorPropertyName - {0} will output whatever error text is found. You can do 'Test 123 {0}' and it will output => Test 123 Field Is Required.
//if errorText contains [[MyLocalizerKeyword]] then the localizer will resolve it. Otherwise it will be treated as a string.
//can do 'Test 123 {0}, [[Validation_Required]]' => Will output 'Test 123 Field Is Required'
//or you can do 'Test {0}, 'You have an error' => Will output 'Test You have an error'

export class ClientSideValidationFactory {

    //func to the model state array
    constructor() {
        this.ErrorConfiguration = [];
    }

    //propertyNameSelector = func selector
    //errorPropertyName = string --> points to the errorModel.PropertyName
    //errorText = uses the default text if not specified [[KeywordFromLocalizer]]
    addRequiredField(propertyNameSelector, errorModelSelector, errorText) {
        this.ErrorConfiguration.push({
            errorModelSelector: errorModelSelector,
            selector: propertyNameSelector,
            errorText: errorText || '[[Validation_Required]]',
            isInvalid: (config, fieldValue) => (fieldValue == null || fieldValue.toString() == '')
        });

        return this;
    }

    addMinLengthOnArray(propertyNameSelector, minLengthOfArray, errorModelSelector, errorText) {
        this.ErrorConfiguration.push({
            errorModelSelector: errorModelSelector,
            selector: propertyNameSelector,
            minLengthOnArray: minLengthOfArray,
            errorText: errorText || '[[Validation_OneItemMustBeSelected]]',
            isInvalid: (config, fieldValue) => (fieldValue == null || fieldValue.length < config.minLengthOnArray)
        });       

        return this;
    }

    restrictMaxLengthOnArray(propertyNameSelector, minLengthOfArray, errorModelSelector, errorText) {
        this.ErrorConfiguration.push({
            errorModelSelector: errorModelSelector,
            selector: propertyNameSelector,
            minLengthOnArray: minLengthOfArray,
            errorText: errorText || '[[Validation_OneItemMustBeSelected]]',
            isInvalid: (config, fieldValue) => (fieldValue == null || fieldValue.length > config.minLengthOnArray)
        });

        return this;
    }

    //_this = Vue instance of this
    //errorModel = object which contains all the errors
    validateForm(_this, errorModel) {
        let passesValidation = true;

        //add prototype items
        //localizationSvc.getRequiredText = localizationSvc.resolveKeyword('Validation_Required');

        //loop through all the configuration rules
        for (var i = 0; i < this.ErrorConfiguration.length; i++) {
            let configToValidate = this.ErrorConfiguration[i];
    
            //is it a valid value?
            if (configToValidate.isInvalid(configToValidate, configToValidate.selector(_this))) {

                //object to see what property is set
                let tempObject = {};

                //go set the error property
                configToValidate.errorModelSelector(tempObject);

                //go set the property to make it reactive
                Object.keys(tempObject).forEach(x => {
       
                    //grab the error text to be displayed
                    let errorText = tempObject[x].replace('{0}', this.getErrorTextFromConfig(configToValidate));

                    //get the current error for this property. this way we just adjust what we need
                    let currentErrors = errorModel[x] || [];
                 
                    //make the property reactive
                    _this.$set(errorModel, x, [errorText].concat(currentErrors.filter(x => x != errorText)));
                });

                passesValidation = false;
            }
        }

        //return the result
        return passesValidation;
    }

    getErrorTextFromConfig(ruleConfig) {
        //should this be localized?
        if (ruleConfig.errorText.startsWith('[[')) {
            return localizationSvc.resolveKeyword(ruleConfig.errorText.replace('[[', '').replace(']]', ''));
        }

        //this should be treated as a raw string
        return ruleConfig.errorText;
    }

}